import { render, staticRenderFns } from "./pileTemplate.vue?vue&type=template&id=4b551700&scoped=true"
import script from "./pileTemplate.vue?vue&type=script&lang=js"
export * from "./pileTemplate.vue?vue&type=script&lang=js"
import style0 from "./pileTemplate.vue?vue&type=style&index=0&id=4b551700&prod&scoped=true&lang=scss"
import style1 from "./pileTemplate.vue?vue&type=style&index=1&id=4b551700&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b551700",
  null
  
)

export default component.exports